import { render, staticRenderFns } from "./SitePie.vue?vue&type=template&id=284e47fe&scoped=true&"
import script from "./SitePie.vue?vue&type=script&lang=js&"
export * from "./SitePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e47fe",
  null
  
)

export default component.exports